import React from 'react';
import MusicGen from './MusicGen';
import './index.css'; 
function App() {
  return (
    <div className="App">
      <MusicGen />
    </div>
  );
}

export default App;
